import { apiClient } from './client';

export function getPlanPackages () {
  return apiClient.get('/plan-packages');
}

export function applyPlanPackage (payload: Record<string, unknown>) {
  return apiClient.put('/plan-packages', payload);
}
